import { MapOverlayContainer } from '../../../../../app-kit/components/PcaMap/subcomponents/MapOverlayContainer/MapOverlayContainer';
import type { LabelWithCoordinates } from '../../../../../app-kit/components/PcaMap/types';
import {
  paletteHelper,
  typographyHelper,
  spacingHelper,
  radiusHelper,
} from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import styled from 'styled-components';
import { PcaMapContext } from '../../../../contexts/PcaMapContext/PcaMapContext';

interface PropertyBoundaryMeasurementLabelsProps {
  propertyBoundaryMeasurements?: LabelWithCoordinates[] | null;
}

const MeasurementLabel = styled.div`
  background-color: ${paletteHelper('backgroundBrandStatic')};
  color: ${paletteHelper('textInverted')};
  border-radius: ${radiusHelper('medium')};
  font-size: ${typographyHelper('overline')};
  text-transform: none;
  padding: ${spacingHelper('twoExtraSmall extraSmall')};
`;

export const PropertyBoundaryMeasurementLabels: FunctionComponent<
  PropertyBoundaryMeasurementLabelsProps
> = ({ propertyBoundaryMeasurements }) => {
  const { isLoading, map } = useContext(PcaMapContext);
  return (
    <>
      {!isLoading &&
        map &&
        propertyBoundaryMeasurements &&
        propertyBoundaryMeasurements.map((measurement) => {
          return (
            <MapOverlayContainer
              key={`${measurement.coordinates.latitude},${measurement.coordinates.longitude}`}
              position={{
                lat: measurement.coordinates.latitude,
                lng: measurement.coordinates.longitude,
              }}
              minZoomLevelToDisplayOverlay={18}
              // minZoomLevelToDisplayOverlay is set here to slightly higher than the zoom level at which google maps generally shows
              // building boundaries since measurement labels take up more space than building boundaries.
              // See: https://developers.google.com/maps/documentation/maps-static/start#Zoomlevels
              map={map}
            >
              <MeasurementLabel>{measurement.label}</MeasurementLabel>
            </MapOverlayContainer>
          );
        })}
    </>
  );
};
